import React from 'react'
import { useHistory } from 'react-router-dom'
import PrimaryTheme from '../../Themes/Primary'

export default function ErrorPageSecured() {
  const history = useHistory();
  const [path, setPath] = React.useState(history.location.pathname)

  React.useEffect(() => {
    let listen = history.listen((location, action) => {
      setPath(history.location.pathname);
    })

    return () => {
      listen();
    }
    
  }, [history])

  return (
    <div className='col-md-12'>
      <div className="row justify-content-center align-items-center bg-white" style={{
        minHeight: '100vh'
      }}>

        <div className="col-md-6">
          <img src="/error1.jpg" className="w-100" alt="Error Page" />
        </div>

        <div className="col-md-6 position-relative" style={{
          // backgroundImage: "url('/error1.jpg')",
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover"
        }}>
          <div className="text-holder">
            <h2 className="text-dark">Page not found.</h2>
            <h5 className="text-dark mt-3">Sorry, we can’t find the page you are looking for.</h5>
            <p className="text-dark mt-3">You may have typed the address incorrectly, or you may have used an outdated
                link.</p>

            <div className="col-md-12 p-0 mt-3 call-to-action pb-3">

              <h4 className="text-dark small mt-4 mb-4">URL Path: <code className="">{path}</code></h4>
              <button className="btn text-bold border-0 border-radius-none" style={{
                background: PrimaryTheme.primary,
                color: PrimaryTheme.white
              }} onClick={() => history.goBack()}>
                <i className="fas fa-arrow-circle-left"></i> Go back</button>
            </div>
          </div>
        </div>

      </div>
    </div >
  )
}
